var useBadgeStyles = function useBadgeStyles(_ref) {
  var variant = _ref.variant,
      color = _ref.color;

  switch (variant) {
    case 'outline':
      return {
        border: '1px solid',
        borderColor: color,
        bg: 'transparent'
      };

    case 'solid':
    default:
      return {
        bg: color
      };
  }
};

export default useBadgeStyles;